<template>
  <div id="app">
    <van-nav-bar title="管理" left-arrow @click-left="onClickLeft" />

    <div v-if="!loDingShow">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          :immediate-check="false"
          offset="10"
          @load="onLoad"
        >
          <van-tabs
            v-model="active"
            ref="reference"
            @click="onClick"
            color="#ff9500"
            animated
            replace
          >
            <van-tab title="订单指派">
              <van-empty description="暂无数据信息!" v-if="HomeList == ''" />
              <div class="list2" v-for="(c, i) in HomeList" :key="i">
                <div>{{ c.sn }}</div>
                <div>
                  <div>企业名称</div>
                  <div>{{ c.companyName }}</div>
                </div>
                <div>
                  <div>{{ c.projectName }}</div>
                  <div>{{ c.workTypeName }}</div>
                </div>
                <van-collapse v-model="activeNames">
                  <van-collapse-item title="详情" :name="i">
                    <div>
                      <div>乘车人</div>
                      <div>{{ c.passengerName }}</div>
                    </div>
                    <div>
                      <div>用车时间</div>
                      <div>{{ c.useCarTime }}</div>
                    </div>

                    <div>
                      <img src="../../assets/qidian2.png" alt="" />
                      <span>{{ c.projectUpAddress }}</span>
                    </div>

                    <div>
                      <img src="../../assets/zhongdian2.png" alt="" />
                      <span>{{ c.projectDownAddress }}</span>
                    </div>

                    <div>
                      <van-field
                        v-model="c.remarks"
                        rows="1"
                        type="textarea"
                        placeholder="订单备注"
                        disabled
                      />
                    </div>

                    <div>
                      <div @click="cannotBeAssigned(c.sn, c.captainAccountId)">
                        无法指派
                      </div>
                      <div
                        @click="
                          ClickXZ(
                            c.sn,
                            c.cityCode,
                            c.cityName,
                            c.captainAccountId
                          )
                        "
                      >
                        指派司机
                      </div>
                    </div>
                  </van-collapse-item>
                </van-collapse>

                <div class="bliAk"></div>
              </div>
            </van-tab>
            <van-tab title="订单管理">
              <div class="home-one-center">
                <van-empty description="暂无数据信息!" v-if="HomeList2 == ''" />
                <div class="list" v-for="(c, i) in HomeList2" :key="i">
                  <div>
                    <div>{{ c.sn }}</div>
                    <div
                      v-if="c.orderStatus == 'ORDER_STATUS-PENDING_SERVICE'"
                      class="colorList1"
                    >
                      待服务
                    </div>
                    <div
                      v-if="c.orderStatus == 'ORDER_STATUS-IN_SERVICE'"
                      class="colorList2"
                    >
                      服务中
                    </div>
                    <div
                      v-if="c.orderStatus == 'ORDER_STATUS-PENDING_AUDIT'"
                      class="colorList2"
                    >
                      待审核
                    </div>
                    <div
                      v-if="c.orderStatus == 'ORDER_STATUS-REJECTED'"
                      class="colorList2"
                    >
                      已驳回
                    </div>
                    <div
                      v-if="c.orderStatus == 'ORDER_STATUS-PENDING_ALLOCATING'"
                      class="colorList2"
                    >
                      待分配
                    </div>
                    <div
                      v-if="c.orderStatus == 'ORDER_STATUS-ALLOCATING'"
                      class="colorList2"
                    >
                      分配中
                    </div>
                  </div>
                  <div>
                    <div>企业名称</div>
                    <div>{{ c.companyName }}</div>
                  </div>
                  <div>
                    <div>{{ c.projectName }}</div>
                    <div>{{ c.workTypeName }}</div>
                  </div>

                  <van-collapse v-model="activeNames2">
                    <van-collapse-item title="详情" :name="i">
                      <div>
                        <div>乘车人</div>
                        <div>{{ c.passengerName }}</div>
                      </div>
                      <div>
                        <div>用车时间</div>
                        <div>{{ c.useCarTime }}</div>
                      </div>
                      <!-- 订单车辆 -->
                      <div class="home-on-center-list-order">
                        <div>
                          <div>订单车辆</div>
                          <div>普通轿车</div>
                        </div>

                        <div>
                          <div>{{ c.driverName }}</div>
                          <div>{{ c.carNumber }}</div>
                        </div>
                      </div>
                      <!-- 订单车辆 -->
                      <div>
                        <img src="../../assets/qidian2.png" alt="" />
                        <span>{{ c.projectUpAddress }}</span>
                      </div>

                      <div>
                        <img src="../../assets/zhongdian2.png" alt="" />
                        <span>{{ c.projectDownAddress }}</span>
                      </div>

                      <div>
                        <van-field
                          v-model="c.remarks"
                          rows="1"
                          type="textarea"
                          placeholder="订单备注"
                          disabled
                        />
                        <!-- disabled -->
                      </div>

                      <div>
                        <div
                          :class="
                            c.orderStatus == 'ORDER_STATUS-PENDING_SERVICE'
                              ? 'button-class2'
                              : 'button-class'
                          "
                          @click="contactthedriver(c.driverMobileNum)"
                        >
                          联系司机
                        </div>
                        <div
                          style="background: #ffffff; color: #212529"
                          :class="
                            c.orderStatus == 'ORDER_STATUS-PENDING_SERVICE'
                              ? 'button-class2'
                              : 'button-class'
                          "
                          @click="contactEngineer(c.sn, c.passengerMobile)"
                        >
                          联系工程师
                        </div>

                        <div
                          style="
                            background: #212526;
                            color: #ffff;
                            width: 137px;
                          "
                          v-if="(c.orderStatus == 'ORDER_STATUS-PENDING_SERVICE' || c.orderStatus == 'ORDER_STATUS-PENDING_AUDIT')&&c.captainAccountId==accountUid"
                          @click="withdrawDriver(c.sn, c.captainAccountId)"
                        >
                          撤回司机
                        </div>
                      </div>
                    </van-collapse-item>
                  </van-collapse>

                  <div class="bliAk"></div>
                </div>
              </div>
            </van-tab>
            <van-tab title="司机管理">
              <!-- 排班日历 -->
              <!-- <div @click="getoscheduing()">排班</div> -->
              <div class="sercer">
                <div @click="cityClick">
                  {{ dq }}
                  <van-icon name="arrow-down" />
                </div>
                <div>
                  <input
                    placeholder="输入司机姓名进行搜索"
                    v-model="textIput"
                  />
                  <div><img :src="imgs" alt="" @click="removeTextIput" /></div>
                </div>
                <div @click="inputSL">搜索</div>
              </div>
              <van-empty description="暂无数据信息!" v-if="list == ''" />
              <div class="home-tow-list">
                <div v-for="(c, i) in list" :key="i" class="listd">
                  <div>
                    <div>
                      <div>{{ c.realName }}</div>
                      <div>{{ c.carNumber }}</div>
                      <div>
                        <img
                          src="../../assets/icon/dh.png"
                          alt=""
                          @click="phone(c.phone)"
                        />
                      </div>
                    </div>
                    <!-- <div @click="show2 = true;sHowname(c.realName)">
								<van-icon name="records" size="22px" color="rgb(255, 149, 0)" />
							</div> -->

                    <div>
                      <div
                        v-if="c.driverStatus == 'CAR_STATUS-FREE'"
                        style="
                          color: #ff9500;
                          background: rgba(255, 149, 0, 0.1);
                          border: 1px solid #ff9500;
                        "
                      >
                        空闲
                      </div>

                      <div
                        v-if="c.driverStatus == 'CAR_STATUS-LIMIT_NUMBER'"
                        style="
                          color: #9ea0a5;
                          background: rgba(33, 37, 41, 0.1);
                          border: 1px solid #9ea0a5;
                        "
                      >
                        限号中
                      </div>

                      <div
                        v-if="c.driverStatus == 'CAR_STATUS-STOPPING'"
                        style="
                          color: #9ea0a5;
                          background: rgba(33, 37, 41, 0.1);
                          border: 1px solid #9ea0a5;
                        "
                      >
                        停车中
                      </div>

                      <div
                        v-if="c.driverStatus == 'CAR_STATUS-APPOINTMENT'"
                        style="
                          color: #9ea0a5;
                          background: rgba(33, 37, 41, 0.1);
                          border: 1px solid #9ea0a5;
                        "
                      >
                        待服务
                      </div>

                      <div
                        v-if="c.driverStatus == 'CAR_STATUS-IN_SERVICE'"
                        style="
                          color: #3278f3;
                          background: rgba(50, 120, 243, 0.1);
                          border: 1px solid #3278f3;
                        "
                      >
                        服务中
                      </div>

                      <div
                        v-if="c.driverStatus == 3"
                        style="
                          color: #e02020;
                          background: rgba(224, 32, 32, 0.1);
                          border: 1px solid #e02020;
                        "
                      >
                        禁用
                      </div>
                      <div
                        v-if="c.driverStatus == 'CAR_STATUS-STOPPING_SERVICE'"
                        style="
                          color: #e02020;
                          background: rgba(224, 32, 32, 0.1);
                          border: 1px solid #e02020;
                        "
                      >
                        暂停派单
                      </div>
                    </div>
                  </div>

                  <div class="home-list-time">
                    <div style="widht: 40px">
                      <div v-show="c.pn != null">车机</div>
                    </div>

                    <div>
                      <div v-show="c.driverOutStr != null">
                        {{ c.driverOutStr }}
                      </div>
                      <!-- <div v-show="i == 1">白班</div>
								<div v-show="i == 4">全天</div> -->
                    </div>
                  </div>
                  <div>
                    <div>
                      <div>
                        {{ c.provinceName }}
                        {{ c.cityName }}
                      </div>
                      <div>总服务次数：{{ c.serviceCount }}次</div>
                    </div>

                    <div
                      v-if="c.driverStatus == 'CAR_STATUS-STOPPING_SERVICE'"
                      @click="Click(c.reason)"
                    >
                      查看原因
                    </div>
                  </div>
                </div>
              </div>
            </van-tab>
          </van-tabs>
        </van-list>
      </van-pull-refresh>
    </div>

    <van-dialog
      v-model="show"
      show-cancel-button
      confirmButtonColor="#212529"
      cancelButtonColor="#626870"
      @confirm="confirms"
      @cancel="cancels"
    >
      <template #title>
        <div class="title">选择无法指派订单原因</div>
      </template>
      <template #default>
        <van-radio-group
          v-model="radio"
          direction="horizontal"
          checked-color="#FF9500"
        >
          <div class="defaults">
            <div v-for="(c, i) in zidian" :key="i">
              <van-radio :name="c.value">{{ c.label }}</van-radio>
            </div>
          </div>
          <div class="defaults caret">
            <van-field
              v-if="radio == '4'"
              v-model="loingField"
              rows="1"
              type="textarea"
              placeholder="订单备注"
            />
          </div>
        </van-radio-group>
      </template>
    </van-dialog>

    <div class="loDingClass" @touchmove.prevent="" v-if="loDingShow">
      <van-loading size="24px" vertical text-color="#ff9500" color="#ff9500"
        >加载中...</van-loading
      >
    </div>

    <!-- 选择城市 -->
    <van-action-sheet
      v-model="actionSheetShow"
      title="城市中文名"
      :round="false"
    >
      <div class="contents">
        <div
          v-for="(c, i) in cityList"
          :key="i"
          class="cityList"
          @click="cellClick(c)"
        >
          {{ c.cityName }}
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import {
  Field,
  NavBar,
  Dialog,
  RadioGroup,
  Radio,
  Icon,
  Tab,
  Tabs,
  Empty,
  Toast,
  PullRefresh,
  List,
  Loading,
  ActionSheet,
  Collapse,
  CollapseItem,
} from "vant";
export default {
  data() {
    return {
      loading: false,
      finished: false,
      active: 0,
      list: [],
      lists: [],
      HomeList: [],
      HomeList2: [],
      HomeList3: [],
      home: 0,
      show: false,
      radio: "1",
      zidian: [],
      loingField: "",
      textIput: "",
      dq: "全部",
      captaincellphone: "",
      imgs: require("@/assets/icon/delete.png"),
      //排班
      text: "",
      show2: false,
      name: "",
      refreshing: false,
      cityCodeID: "",
      current: 1,
      loDingShow: false,
      actionSheetShow: false,
      cityList: [],
      activeNames: [0],
      activeNames2: [0],
	  accountUid:"",
    };
  },
  created() {
	  
	  this.accountUid=localStorage.getItem("accountUid")
    // this.active= JSON.parse( localStorage.getItem('name'))
  },
  methods: {
    // 选择城市
    cellClick(e) {
      var that = this;
      // cityCode: "130200"
      // cityName: "唐山市"
      this.dq = e.cityName;
      this.cityCodeID = e.cityCode;
      //  每次切换的时候 首先去除加载的样式
      that.finished = false;
      that.loading = false;
      // 默认加载
      that.loDingShow = true;
      // 设置为第一页
      that.current = 1;
      // 去除三个页面数据
      that.list = [];
      setTimeout(function () {
        that.get();
        that.actionSheetShow = false;
      }, 200);
      console.log(e);
    },
    // 加载方法
    onLoad() {
      if (this.active == 0) {
        this.current++;
        this.Orderassignment();
      }
      if (this.active == 1) {
        this.current++;
        this.Ordermanagement();
      }

      if (this.active == 2) {
        this.current++;
        this.get();
      }
      // Ordermanagement
    },
    // 刷新方法
    onRefresh() {
      this.current = 1;
      this.finished = false;
      this.loading = false;
      // 默认加载
      this.loDingShow = true;

      console.log(this.active);

      this.list = [];
      this.HomeList = [];
      this.HomeList2 = [];
      let that = this;
      setTimeout(function () {
        if (that.active == 0) {
          // 订单指派
          that.Orderassignment();
        } else if (that.active == 1) {
          // 订单管理
          that.Ordermanagement();
        } else if (that.active == 2) {
          // 司机管理
          that.get();
        }
      }, 500);
    },
    //  排班按钮目前已经隐藏
    getoscheduing() {
      this.$router.push({
        name: "scheduling",
      });
    },
    // 安卓按钮
    onClickLeft() {
      window.open("app:/#/finish");
    },
    // tab切换按钮
    onClick(name, title) {
      console.log(name);
      //  每次切换的时候 首先去除加载的样式
      this.finished = false;
      this.loading = false;
      // 默认加载
      this.loDingShow = true;
      // 设置为第一页
      this.current = 1;
      // 去除三个页面数据
      this.list = [];
      this.HomeList = [];
      this.HomeList2 = [];

      if (name == 0) {
        // 订单指派
        this.Orderassignment();
      } else if (name == 1) {
        // 订单管理
        this.Ordermanagement();
      } else if (name == 2) {
        // 司机管理
        this.get();
      }
    },
    // 订单指派
    Orderassignment() {
      //
      this.$axios({
        url: `/vedm/captainApp/getCaptainOrderPage/${localStorage.getItem(
          "accountUid"
        )}/assign?size=10&current=${this.current}`,
        method: "get",
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      })
        .then((res) => {
          if (res.data.code == 0) {
            // 默认加载
            this.loDingShow = false;
            console.log(res.data.data);

            // activeNames
            if (res.data.data.ordersList) {
              var listd = [...this.HomeList, ...res.data.data.ordersList];
              this.HomeList = listd;
              this.loading = false;

              if (res.data.data.ordersList.length == 0) {
                this.loading = true;
                this.finished = true;
              }
            } else {
              this.loading = true;
              this.finished = true;
            }
            this.refreshing = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.refreshing = false;
        });
    },
    // 订单管理
    Ordermanagement() {
      this.$axios({
        url: `/vedm/captainApp/getCaptainOrderPage/${localStorage.getItem(
          "accountUid"
        )}/show?size=10&current=${this.current}`,
        method: "get",
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      })
        .then((res) => {
          if (res.data.code == 0) {
            // 默认加载
            this.loDingShow = false;
            this.captaincellphone = res.data.data.driverCaptainIdentity.phone;

            if (res.data.data.ordersList.length) {
              var listd = [...this.HomeList2, ...res.data.data.ordersList];
              this.HomeList2 = listd;
              this.loading = false;

              if (res.data.data.ordersList.length == 0) {
                this.loading = true;
                this.finished = true;
              }
            } else {
              this.loading = true;
              this.finished = true;
            }
            this.refreshing = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.refreshing = false;
        });
    },
    //拨打电话
    phone(p) {
      window.open("app:/#/call_driver?" + p + "&driver");
    },
    // 安卓按钮
    contactthedriver(p) {
      window.open("app:/#/call_driver?" + p + "&driver");
    },
    // 安卓按钮
    contactEngineer(sn, passengerMobile) {
      window.open(
        "app:/#/call_engineer?" +
          sn +
          "&" +
          this.captaincellphone +
          "&" +
          passengerMobile +
          "&engineer"
      );
    },
    // 撤回按钮
    withdrawDriver(c, e) {
      Dialog.confirm({
        title: "撤回司机",
        message: "是否撤回该司机！",
      })
        .then(() => {
          Toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true,
          });
          this.$axios
            .post(
              "/vedm/captainApp/liberateDriverBySn",
              {
                captainAccountId: e,
                sn: c,
              },
              {
                headers: {
                  Authorization: localStorage.getItem("token"),
                },
              }
            )
            .then((res) => {
              let that = this;
              if (res.data.code == "0") {
                Dialog.alert({
                  title: "提示",
                  message: "司机已撤回！",
                }).then(() => {
                  //  每次切换的时候 首先去除加载的样式
                  that.finished = false;
                  that.loading = false;
                  // 默认加载
                  that.loDingShow = true;
                  // 设置为第一页
                  that.current = 1;
                  // 去除三个页面数据
                  that.list = [];
                  that.HomeList = [];
                  that.HomeList2 = [];

                  // location.reload();
                  that.Ordermanagement();
                });
              }
              Toast.clear();
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    // tab(i) {
    // 	this.home = i;
    // },
    // 司机无法出车详细原因按钮
    Click(e) {
      Dialog.alert({
        title: "详细原因",
        message: e,
      });
    },
    // 删除输入框内容按钮
    removeTextIput() {
      var that = this;
      if (this.textIput.length >= 1) {
        // 清空输入框
        that.textIput = "";
        //  每次切换的时候 首先去除加载的样式
        that.finished = false;
        that.loading = false;
        // 默认加载
        that.loDingShow = true;
        // 设置为第一页
        that.current = 1;
        // 去除当前页面数据
        that.list = [];
        setTimeout(function () {
          // 延迟加载一下
          that.get();
        }, 200);
      }
    },
    // 进入地区页面
    cityClick() {
      this.$axios
        .get(
          `/vedm/captainApp/captainCityList/${localStorage.getItem(
            "accountUid"
          )}`,
          {
            headers: {
              Authorization: localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          this.actionSheetShow = true;
          if (res.data.code == 0) {
            res.data.data.unshift({
              cityName: "全部",
              cityCode: "",
            });
            this.cityList = res.data.data;
          }
        });
    },
    // 司机 搜索  搜索去除size
    inputSL() {
      var that = this;
      // get
      // carNumber
      // 当输入的长度大于1的时候
      if (that.textIput.length >= 1) {
        //  每次切换的时候 首先去除加载的样式
        that.finished = false;
        that.loading = false;
        // 默认加载
        that.loDingShow = true;
        // 设置为第一页
        that.current = 1;
        // 去除当前页面数据
        that.list = [];
        // 最后再加载一次
        setTimeout(function () {
          that.get();
        }, 200);
      }
      // this.lists.forEach((res) => {
      //   if (res.realName.includes(this.textIput)) {
      //     this.list.push(res);
      //   }
      // });
      // }
      // else if (this.textIput.length <= 0) {
      //   this.list = this.lists;
      // }
    },
    // 指派司机按钮
    ClickXZ(sn, cityCode, cityName, captainAccountId) {
      this.$router.push({
        path: `XZvehicles?sn=${sn}&cityCode=${cityCode}&cityName=${cityName}&captainAccountId=${captainAccountId}&id=${this.active}`,
      });
    },
    // 司机管理  数据接口
    get() {
      // realName 姓名     cityCode 市code
      // 司机管理
      // cityCodeID
      this.$axios({
        url: `/vedm/captainApp/getCaptainManagerDriverList/${localStorage.getItem(
          "accountUid"
        )}?cityCode=${this.cityCodeID}&realName=${
          this.textIput
        }&size=20&current=${this.current}`,
        method: "get",
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      })
        .then((res) => {
          console.log(res.data.data);

          // console.log(this.active, "222222")
          if (res.data.code == 0) {
            // 请求成功先显示弹框
            this.loDingShow = false;

            if (res.data.data) {
              // 数组合并
              var listd = [...this.list, ...res.data.data];
              this.list = listd;
              this.loading = false;
              // 当获取的数组为0的时候继续合并
              if (res.data.data.length == 0) {
                // 显示已经更多
                this.loading = true;
                this.finished = true;
              }
            } else {
              this.loading = true;
              this.finished = true;
            }

            this.refreshing = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.refreshing = false;
        });
    },
    // 点击无法指派按钮
    cannotBeAssigned(c, e) {
      // console.log(c, "2222222");
      this.odersn = c;
      this.captainId = e;
      // 无法指派
      this.show = true;
      this.$axios
        .get("/admin/dict/type/vedm_order_unable_assign", {
          headers: {
            Authorization: localStorage.getItem("token"),
          },
        })
        .then((res) => {
          console.log(res.data.data);
          this.zidian = res.data.data;
        });
    },
    //  订单指派确定按钮
    confirms() {
      this.$axios
        .post(
          "/vedm/captainApp/confirmCaptain4Order",
          {
            captainId: this.captainId,
            reason: this.loingField.length >= 1 ? this.loingField : this.radio,
            reasonType: this.radio,
            sn: this.odersn,
          },
          {
            headers: {
              Authorization: localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          Dialog.alert({
            title: "提示",
            message: res.data.msg,
          }).then(() => {
            console.log("确定");
            var that = this;
            //  每次切换的时候 首先去除加载的样式
            that.finished = false;
            that.loading = false;
            // 默认加载
            that.loDingShow = true;
            // 设置为第一页
            that.current = 1;
            // 去除三个页面数据
            that.list = [];
            that.HomeList = [];
            that.HomeList2 = [];

            setTimeout(function () {
              that.Orderassignment();
            }, 500);
          });
        });
    },
    // 订单指派取消按钮
    cancels() {
      console.log("取消");
    },
  },

  mounted() {
    var that = this;

    if (this.$route.query.cityName) {
      console.log(this.$route.query.cityCode);
      this.loading = false;
      this.finished = false;
      this.current = 1;
      this.loDingShow = true;

      this.cityCodeID =
        this.$route.query.cityCode != undefined
          ? this.$route.query.cityCode
          : "";
      this.dq = this.$route.query.cityName;
      this.get();
    } else {
      this.dq = "全部";
      this.get();
      // this.list = res.data.data;
      // this.lists = res.data.data;
    }
    // /vedm/captainApp/captainCityList/{accountId}
    // 获取手机号
    // accountUid

    // 订单指派
    this.Orderassignment();
    this.get();

    if (this.$route.query.num) {
      this.$refs.reference.currentIndex = this.$route.query.num;
    } else {
      this.$refs.reference.currentIndex = 0;
    }
  },
  components: {
    "van-nav-bar": NavBar,
    "van-field": Field,
    [Dialog.Component.name]: Dialog.Component,
    "van-radio-group": RadioGroup,
    "van-radio": Radio,
    "van-icon": Icon,
    "van-tab": Tab,
    "van-tabs": Tabs,
    "van-empty": Empty,
    "van-pull-refresh": PullRefresh,
    "van-list": List,
    "van-loading": Loading,
    "van-action-sheet": ActionSheet,
    "van-collapse": Collapse,
    "van-collapse-item": CollapseItem,
  },
};
</script>

<style lang='less' scoped>
/deep/.van-action-sheet {
  height: 100% !important;
  max-height: 100% !important;
}
.contents {
  padding: 16px 16px 160px;
}
.cityList {
  width: 100%;
  height: 44px;
  background: #ffffff;
  padding: 0 0 0 15px;
  color: black;
  font-size: 12px;
  display: flex;
  align-items: center;
  caret-color: rgba(0, 0, 0, 0);
}

.loDingClass {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
}
.button-class {
  width: 121px !important;
  height: 38px;
}

.button-class2 {
  width: 88px !important;
  height: 38px;
}

.home-on-center-list-order {
  display: flex;

  align-items: center;
  margin-bottom: 26px;

  > div {
    display: flex;
    align-items: center;
    color: black;
    font-size: 14px;

    > div:nth-child(1) {
      margin-right: 5px;
    }
  }

  > div:nth-child(1) {
    color: #9ea0a5;

    > div:nth-child(2) {
      padding: 2px;
      border: 1px solid #9ea0a5;
      border-radius: 5px;
      font-size: 12px;
    }
  }
}

.defaults {
  width: 100%;
  padding: 0 17px 0 54px;

  /deep/.van-radio {
    width: 100%;
    display: flex;
  }

  /deep/.van-radio__icon {
    margin: 0 26px;
  }

  > div {
    width: 224px;
    margin: 9px 0;
    display: flex;
    justify-content: center;
  }
}

.title {
  font-size: 15px;
  font-weight: 500;
  color: #212529;
  margin-bottom: 25px;
}

.home-tow-list {
  margin: 20px 0;

  .listd {
    width: 100%;
    padding: 0 15px 34px 15px;
    position: relative;

    img {
      width: 20px;
      height: 20px;
      position: absolute;
      left: 50%;
      top: 0;
    }

    > div:nth-child(1) {
      display: flex;
      justify-content: space-between;
      margin-bottom: 2px;

      > div:nth-child(1) {
        display: flex;

        > div:nth-child(1) {
          font-size: 15px;
          font-weight: 500;
          color: #212529;
        }

        > div:nth-child(2) {
          font-size: 14px;
          color: #212529;
          margin: 0 18px 0 21px;
        }
      }

      > div:nth-child(2) {
        font-size: 12px;

        > div {
          padding: 2px 5px;
          border-radius: 4px;
        }
      }
    }

    .home-list-time {
      display: flex;
      margin: 10px 0;

      > div > div {
        padding: 3px 10px;
        background: #ff9500;
        color: #fff;
        margin: 0 5px;
        border-radius: 5px;
        font-size: 12px;
        transform: scale(0.8);
      }

      > div:nth-child(2) {
        display: flex;
      }

      > div:nth-child(1) {
        width: 60px !important;
      }

      > div:nth-child(1) > div:nth-child(1) {
        border: 1px solid #c1c2c6;
        background: #fff;
        color: #c1c2c6;
        transform: scale(0.9);
      }
    }

    > div:nth-child(3) {
      display: flex;
      justify-content: space-between;

      > div:nth-child(1) {
        font-size: 12px;
        color: #626870;
        display: flex;
        align-items: center;

        > div:nth-child(1) {
          margin-right: 14px;
        }
      }

      > div:nth-child(2) {
        border-radius: 6px;
        border: 1px solid #212529;
        padding: 4px;
        color: #212529;
        font-size: 12px;
      }
    }
  }
}

.sercer {
  width: 100%;
  display: flex;
  height: 30px;
  margin-top: 10px;

  > div:nth-child(1) {
    width: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-right: 1px solid #e8e9eb;
    caret-color: rgba(0, 0, 0, 0);
  }

  > div:nth-child(2) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 240px;
    padding: 0 16px;
  }

  > div:nth-child(3) {
    width: 58px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-left: 1px solid #e8e9eb;
    caret-color: rgba(0, 0, 0, 0);
  }

  input {
    width: 100%;
    caret-color: rgb(0, 0, 0);
  }
}

.list {
  width: 100%;
  padding: 0 15px;
  font-size: 14px;

  > div:nth-child(1) {
    margin-top: 9px;
    font-size: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  > div:nth-child(2) {
    height: 49px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    > div:nth-child(2) {
      color: #212529;
    }
  }

  > div:nth-child(3) {
    margin-bottom: 27px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    > div:nth-child(1) {
      color: #212529;
      font-weight: 500;
    }

    > div:nth-child(2) {
      padding: 3px;
      background: #ff9500;
      border-radius: 4px;
      color: #ffffff;
      font-size: 12px;
      /* line-height: 20px; */
      text-align: center;
    }
  }

  // > div:nth-child(4),
  // > div:nth-child(5) {
  //   height: 49px;
  //   margin-bottom: 5px;

  //   > div:nth-child(2) {
  //     color: #212529;
  //   }
  // }

  // > div:nth-child(7),
  // > div:nth-child(8) {
  //   font-size: 12px;
  //   display: flex;
  //   margin-bottom: 17px;
  //   align-items: flex-start;

  //   > img {
  //     width: 20px;
  //     height: 20px;
  //     margin-right: 3px;
  //   }

  //   span {
  //     display: block;
  //     height: 40px;
  //     /* line-height: 25px; */

  //     width: 327px;
  //     align-items: center;

  //     height: 34px;
  //   }
  // }

  // > div:nth-child(9) {
  //   caret-color: rgb(0, 0, 0);
  // }

  // > div:nth-child(10) {
  //   font-size: 15px;
  //   margin: 0 0 9px 0;
  //   display: flex;
  //   justify-content: space-around;

  //   > div {
  //     height: 38px;
  //     display: flex;
  //     justify-content: center;
  //     align-items: center;
  //     border-radius: 6px;
  //     border: 1px solid #212529;
  //   }

  //   > div:nth-child(1) {
  //     color: #212529;
  //   }

  //   > div:nth-child(2) {
  //     background: #212529;
  //     color: #ffffff;
  //   }
  // }

  // > div:nth-child(11) {
  //   margin-left: -15px;

  //   width: 375px;
  //   height: 20px;
  //   background: #f7f7f7;
  // }

  /deep/.van-cell {
    padding: 10px 0 !important;
  }
  /deep/.van-collapse-item__content {
    padding: 0 !important;

    > div:nth-child(1),
    > div:nth-child(2) {
      height: 49px;
      margin-bottom: 5px;

      > div:nth-child(2) {
        color: #212529;
      }
    }

    > div:nth-child(4),
    > div:nth-child(5) {
      font-size: 12px;
      display: flex;
      margin-bottom: 17px;
      align-items: flex-start;

      > img {
        width: 20px;
        height: 20px;
        margin-right: 3px;
      }

      span {
        display: block;
        height: 40px;
        /* line-height: 25px; */

        width: 327px;
        align-items: center;

        height: 34px;
      }
    }

    > div:nth-child(6) {
      caret-color: rgb(0, 0, 0);
    }

    > div:nth-child(7) {
      font-size: 15px;
      margin: 0 0 9px 0;
      display: flex;
      justify-content: space-around;

      > div {
        height: 38px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 6px;
        border: 1px solid #212529;
      }

      > div:nth-child(1) {
        color: #212529;
      }

      > div:nth-child(2) {
        background: #212529;
        color: #ffffff;
      }
    }

   
    > div {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
    .bliAk {
    margin-left: -15px;
    width: 375px;
    height: 10px;
    background: #f7f7f7;
  }

  // > div {
  //   display: flex;
  //   justify-content: space-between;
  //   align-items: center;
  // }
}

.list2 {
  width: 100%;
  padding: 0 15px;
  font-size: 14px;

  > div:nth-child(1) {
    margin-top: 9px;
    font-size: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  > div:nth-child(2) {
    height: 49px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    > div:nth-child(2) {
      color: #212529;
    }
  }

  > div:nth-child(3) {
    margin-bottom: 27px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    > div:nth-child(1) {
      color: #212529;
      font-weight: 500;
    }

    > div:nth-child(2) {
      padding: 3px;
      background: #ff9500;
      border-radius: 4px;
      color: #ffffff;
      font-size: 12px;
      /* line-height: 20px; */
      text-align: center;
    }
  }

  /deep/.van-cell {
    padding: 10px 0 !important;
  }

  /deep/.van-collapse-item__content {
    padding: 0 !important;
    > div {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    > div:nth-child(1),
    > div:nth-child(2) {
      height: 49px;
      margin-bottom: 5px;

      > div:nth-child(2) {
        color: #212529;
      }
    }

    > div:nth-child(3),
    > div:nth-child(4) {
      font-size: 12px;
      display: flex;
      margin-bottom: 17px;
      align-items: flex-start;

      > img {
        width: 20px;
        height: 20px;
        margin-right: 3px;
        margin-top: -3px;
      }

      span {
        display: block;
        height: 40px;
        /* 	line-height: 25px; */

        width: 327px;
        align-items: center;

        height: 34px;
      }
    }

    > div:nth-child(5) {
      caret-color: rgb(0, 0, 0);
    }

    > div:nth-child(6) {
      font-size: 15px;
      margin: 0 0 9px 0;

      > div {
        height: 38px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 6px;
        border: 1px solid #212529;
      }

      > div:nth-child(1) {
        width: 168px;
        color: #212529;
      }

      > div:nth-child(2) {
        width: 168px;

        background: #212529;
        color: #ffffff;
      }
    }

    > div:nth-child(10) {
      margin-left: -15px;

      width: 375px;
      height: 20px;
      background: #f7f7f7;
    }
  }

  // > div:nth-child(4),
  // > div:nth-child(5) {
  //   height: 49px;
  //   margin-bottom: 5px;

  //   > div:nth-child(2) {
  //     color: #212529;
  //   }
  // }

  // > div:nth-child(6),
  // > div:nth-child(7) {
  //   font-size: 12px;
  //   display: flex;
  //   margin-bottom: 17px;
  //   align-items: flex-start;

  //   > img {
  //     width: 20px;
  //     height: 20px;
  //     margin-right: 3px;
  //     margin-top: -3px;
  //   }

  //   span {
  //     display: block;
  //     height: 40px;
  //     /* 	line-height: 25px; */

  //     width: 327px;
  //     align-items: center;

  //     height: 34px;
  //   }
  // }

  // > div:nth-child(8) {
  //   caret-color: rgb(0, 0, 0);
  // }

  // > div:nth-child(9) {
  //   font-size: 15px;
  //   margin: 0 0 9px 0;

  //   > div {
  //     height: 38px;
  //     display: flex;
  //     justify-content: center;
  //     align-items: center;
  //     border-radius: 6px;
  //     border: 1px solid #212529;
  //   }

  //   > div:nth-child(1) {
  //     width: 168px;
  //     color: #212529;
  //   }

  //   > div:nth-child(2) {
  //     width: 168px;

  //     background: #212529;
  //     color: #ffffff;
  //   }
  // }

  .bliAk {
    margin-left: -15px;
    width: 375px;
    height: 10px;
    background: #f7f7f7;
  }

  // > div {
  //   display: flex;
  //   justify-content: space-between;
  //   align-items: center;
  // }
}

.colorList1 {
  width: 45px;
  height: 14px;
  background: rgba(33, 37, 41, 0.1);
  border-radius: 2px;
  border: 1px solid #9ea0a5;
  font-size: 11px;
  font-weight: 400;
  color: #9ea0a5;
  /* 	line-height: 14px; */
  text-align: center;
}

.colorList2 {
  width: 45px;
  height: 14px;
  background: rgba(50, 120, 243, 0.1);
  border-radius: 2px;
  border: 1px solid #3278f3;
  font-size: 11px;
  font-weight: 400;
  color: #3278f3;
  /* line-height: 14px; */
  text-align: center;
}

/deep/.van-field--min-height .van-field__control {
  background-color: #f7f7f7 !important;
  height: 60px;
  padding: 9px;
}

.headers {
  width: 100%;
  height: 6px;
  background: #f7f7f7;
}

#app {
  caret-color: rgba(0, 0, 0, 0);
  font-size: 14px;
  color: #9ea0a5;
}

.header {
  width: 100%;
  height: 44px;
  padding: 0px 72px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.color {
  color: #ff9500;
}

.caret {
  caret-color: rgb(0, 0, 0);
}
</style>
